import crossfilter from 'crossfilter2';
import reductio from 'reductio'


export const stackSecond = (data, needed) => {
    return {
      all: function() {
        let m = {};
        // build matrix from multikey/value pairs
        data.forEach(function(kv) {
          let ks = kv.key;
          ks[0] = ks[0] ? ks[0] : 'NA'
          m[ks[0]] = m[ks[0]] || Object.fromEntries(needed.map(n => [n.key,0]));
          const neededKey = needed.map(n => n.key)
          if(ks[1] && neededKey.includes(ks[1])) m[ks[0]][ks[1]] = kv.value;
        });
        // then produce multivalue key/value pairs
        return Object.entries(m).map(([key,value]) => ({key,value}));
      }
    };
}
export const splitGroup = (group2d, props) => {
    return {
      subgroup: function(key) {
        return {
          all: function() {
            let fdata = group2d.all().filter(function(kv) {
              return kv.key[Object.keys(kv.key).length - 1] === key;
            })
            fdata = props.stackNeeded ? stackSecond(fdata, props.stackNeeded).all() : fdata.map(function(kv) {
                return {
                    key: kv.key[0] ? kv.key[0] : 'NA',
                    value: Object.keys(kv.key).length > 2 ? {[kv.key[1]] : kv.value} : kv.value
                };
            })       
            fdata.sort(function(a, b) {
              return a.key - b.key;
            })
            return fdata
          }
        };
      }
    };
}
export const createDimensions = ({dimensions, data}) => {
    if (!dimensions || !data) return
    const filter = crossfilter(data);
    const dimensionsList = []
    for (const dimension of dimensions){
        const checkDimension = dimension.split('*')
        const value = filter.dimension(d => { return checkDimension.length > 1 ? [d[checkDimension[0]], d[checkDimension[1]], d['metricName']] : [d[checkDimension[0]], d['metricName']] });
        const valueGroup = value.group().reduceSum(d => d['metric']);
        dimensionsList.push({[dimension]: {dim: value, group: valueGroup}});
    }
    return dimensionsList
}

export const createHierarchyDimensions = ({dimensions, data}) => {
    if (!dimensions || !data) return
    const filter = crossfilter(data);
    const hierarchyDimensionsList = []
    for (const dimension of dimensions){
        const checkDimension = dimension.split('*')
        const value = filter.dimension(d => { return checkDimension.length > 1 ? [d[checkDimension[0]], d[checkDimension[1]], d['metricName']] : [d[checkDimension[0]], d['metricName']] });
        const valueGroup = value.group().reduceSum(d => d['metric']);
        hierarchyDimensionsList.push({[dimension]: {dim: value, group: valueGroup}});
    }
    return hierarchyDimensionsList
}
export const getDimension = ({filter, data, metricName}) => {
    if(!filter || !data) return 
    const filterDimData = data.filter(d => d[filter])
    return filterDimData
}

export const treeData = ({data, currentLevel, currentSelections}) => {
    if (!data || !currentLevel) return
    const hierarchyList = []
    for (const d of data){
        const currentData = d[currentLevel]
        hierarchyList.push({[currentLevel]: {...currentData}});
    }
    return hierarchyList
}

export const getAverage = ({dim}) => {
    if (!dim) return
    let group = dim.group()
    let reducer = reductio()
    .count(true)
    .sum(function(d) { return d['metric']; })
    .avg(true);
    reducer(group);
    return group
}